import { Button } from "@/components/button";
import { FONT, MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Divider, Flex, Img, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { type FooterProps } from "./types";

export const Footer = ({ logoUrl, isPrivate, pensionInfo, ybs, yeogi }: FooterProps) => {
    const { isTablet } = MEDIA();
    const getDefaultParams = getDefaultParameters();
    const { idx } = getDefaultParams;
    return (
        <S.Wrapper>
            <Center
                w={isTablet ? "100%" : "1184px"}
                justifyContent={isTablet ? "center" : "space-evenly"}
                rowGap={isTablet ? "24px" : ""}
                flexDir={isTablet ? "column" : "row"}
            >
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        {idx === "2017" ? "HOTEL INFO" : "PENSION INFO"}
                    </Text>
                    <Center flexDir="column" className="pension_detail_info">
                        <Center columnGap="8px">
                            <Text>상호 : {pensionInfo?.name.kr}</Text>
                            {ybs && <Link to={`${ybs}`}>YBS</Link>}
                            {yeogi && <Link to={`${yeogi}`}>여기어때 예약</Link>}
                        </Center>
                        <Text>주소 : {pensionInfo?.address}</Text>
                        <Text>사업자 번호 : {pensionInfo?.bizNumber}</Text>
                        {pensionInfo?.farmNumber && (
                            <Flex gap="4px">
                                <Text>농어촌민박 </Text>
                                <Box
                                    w="24px"
                                    h="24px"
                                    background={`url(${process.env.PUBLIC_URL}/assets/farm_logo.png) no-repeat center/cover`}
                                />
                                <Text> {pensionInfo.farmNumber}</Text>
                            </Flex>
                        )}
                    </Center>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="32px" alignItems="center" w="320px">
                    <Img src={logoUrl} w="184px" h="60px" />
                    <Text fontSize="14px">Copyright(C) 2022 MarginMax All Right Reserved</Text>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        NUMBER INFO
                    </Text>
                    <Flex flexDir="column" rowGap="24px">
                        {isPrivate && (
                            <Box className="pension_private_info">
                                <Text>전화 : {pensionInfo?.phoneNumber}</Text>
                                {idx !== "2017" && <Text>계좌번호 : {pensionInfo?.account}</Text>}
                            </Box>
                        )}
                        <Button size="tiny" border="none">
                            <Link to="http://marginmax.me/login">관리자 로그인</Link>
                        </Button>
                    </Flex>
                </Flex>
            </Center>
        </S.Wrapper>
    );
};

const Wrapper = styled.footer`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
    border-top: 1px solid ${({ theme }) => theme.COLOR.text[300]};

    & .pension_detail_info p,
    a {
        ${FONT("pretendard", 14, 300)}
    }

    & .pension_private_info > p {
        ${FONT("pretendard", 14, 300)}
    }
`;

const S = { Wrapper };
